import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { IconButton } from 'ksnm-common-ui/lib/IconButton';

import { RoutePath } from '@components/AppRouter/constants';
import { NEW_ENTITY_ID } from '@components/AppRouter/hooks/constants';
import { usePermission } from '@src/utils/hooks/usePermission';
import { useToggleFullSize } from '@src/utils/hooks/useToggleFullSize';
import { confirmDialogStore } from '@stores/confirmDialog';
import { constantStore } from '@stores/constantStore';
import { reportsStore } from '@stores/dictionaryStores/reports/reportsStore';

import { columns } from '../columns';

const { TABLE_NAMES } = constantStore;

export const ActionButton = observer(({ update }: { update: () => void }) => {
  const { push } = useHistory();
  const { groupDelete, fullSize, checked, setChecked, toggleFullSize } = reportsStore;
  const { open: openConfirmDialog } = confirmDialogStore;

  const onToggleFullSize = useToggleFullSize({
    tableName: TABLE_NAMES.DICTIONARY_REPORT,
    columns,
    fullSize,
    toggle: toggleFullSize,
    update,
  });

  const permission = usePermission('CmReport');

  const onCreate = useCallback(() => {
    push(`${RoutePath.DICTIONARY_REPORT}/${NEW_ENTITY_ID}`);
  }, [push]);

  const onEdit = useCallback(() => {
    push(`${RoutePath.DICTIONARY_REPORT}/${checked[0]?.code}`);
  }, [checked, push]);

  const onDelete = useCallback(() => {
    openConfirmDialog({
      text: `Удалить выбранные элементы (${checked.length})?`,
      onOk: () => {
        const items = checked.map((item) => item.code);

        groupDelete(items as string[]).then(() => {
          setChecked([]);
          update();
        });
      },
    });
  }, [checked, groupDelete, openConfirmDialog, setChecked, update]);

  return (
    <>
      {permission.CREATE && <IconButton onClick={onCreate} iconName="add" title="Добавить" />}
      {permission.UPDATE && (
        <IconButton
          onClick={onEdit}
          disabled={!(checked.length == 1 && checked[0].regulated === false)}
          iconName="edit"
          title="Редактировать"
        />
      )}
      {permission.DELETE && (
        <IconButton
          onClick={onDelete}
          disabled={checked.length === 0 || !checked.every((el) => el?.regulated === false)}
          iconName="delete"
          title="Удалить"
        />
      )}
      <IconButton
        onClick={onToggleFullSize}
        iconName={fullSize ? 'fullScreenOpen' : 'fullScreenClose'}
        title={fullSize ? 'Уменьшить' : 'Увеличить'}
      />
    </>
  );
});
